import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { startWith } from 'rxjs';
import { FORM_REGISTER } from 'src/app/pages/projects-repository/register/project/project-register.component';
import { PsaProjectData } from 'src/app/shared/interfaces/psa-project-register';

@Component({
  standalone: false,
  selector: 'app-psa-step-co-benefits',
  templateUrl: './step-coBenefits.component.html',
  styleUrls: ['./step-coBenefits.component.scss']
})
export class PsaStepCoBenefitsComponent implements OnInit {
  public today = new Date();
  public maxDate: Date;
  public minDate: Date;
  public errorMsg = "Data inválida ou não preenchida";

  characterCount: number = 0;

  date: boolean = true;
  isInvalidDate : boolean = false;
 
  constructor(
    @Inject(FORM_REGISTER) public formRegister: FormGroup,
    @Inject('projectDraftData') public projectDraftData: PsaProjectData,
  ) {
    const currentYear = new Date().getFullYear();
    this.maxDate = new Date(currentYear, 11, 31);
    this.minDate = new Date(1992, 0, 1);
  }

  ngOnInit(): void {
    this.formRegister.get('coBenefits')?.valueChanges
    .pipe(
      startWith(this.formRegister.get('coBenefits')?.value || '')
    )
    .subscribe(value => {
      this.characterCount = value ? value.length : 0;
    });
  }

  onBlurDate(date: Date, inputId: string) {
    this.formRegister.get(inputId)?.setValue(date);
    this.date = false;
    this.isInvalidDate = date > this.today || date < this.minDate;
  }

  public checkHasError(fieldName: string, errorCode?: string): boolean {
    let field = this.formRegister.get(fieldName);
    if (field == null || !field.touched) {
      return false;
    }
    if (errorCode == null) {

      return field.invalid;
    }
    return field.hasError(errorCode);
  }

  isOdsMissing(): boolean {
    const control = this.formRegister.get('odsNumbers');
    return !!control?.hasError('required') && !!control.touched;
  }
}